import {
  FETCH_ADMIN_COMPANY_PROFILES_FOR_REVIEW,
  FETCH_ADMIN_EXPIRED_JOBS,
  FETCH_ADMIN_FREE_COMPANY_LOGOS_FOR_REVIEW,
  FETCH_ADMIN_FREE_JOBS_UNDER_REVIEW,
  FETCH_ADMIN_PAID_COMPANY_LOGOS_FOR_REVIEW,
  FETCH_ADMIN_PAID_JOBS_UNDER_REVIEW,
  FETCH_ADMIN_PROMOTIONAL_REQUESTS,
  FETCH_ADMIN_REQUESTED_DELETE_ACCOUNTS,
} from "./adminConstants";

export function fetchAdminPaidJobsUnderReview(jobs) {
  return {
    type: FETCH_ADMIN_PAID_JOBS_UNDER_REVIEW,
    payload: jobs,
  };
}

export function fetchAdminFreeJobsUnderReview(jobs) {
  return {
    type: FETCH_ADMIN_FREE_JOBS_UNDER_REVIEW,
    payload: jobs,
  };
}

export function fetchAdminExpiredJobs(jobs) {
  return {
    type: FETCH_ADMIN_EXPIRED_JOBS,
    payload: jobs,
  };
}

export function fetchAdminPromotionalRequests(requests) {
  return {
    type: FETCH_ADMIN_PROMOTIONAL_REQUESTS,
    payload: requests,
  };
}

export function fetchAdminPaidCompanyLogosForReview(logos) {
  return {
    type: FETCH_ADMIN_PAID_COMPANY_LOGOS_FOR_REVIEW,
    payload: logos,
  };
}

export function fetchAdminFreeCompanyLogosForReview(logos) {
  return {
    type: FETCH_ADMIN_FREE_COMPANY_LOGOS_FOR_REVIEW,
    payload: logos,
  };
}

export function fetchAdminCompanyProfilesForReview(companies) {
  return {
    type: FETCH_ADMIN_COMPANY_PROFILES_FOR_REVIEW,
    payload: companies,
  };
}

export function fetchAdminRequestedDeleteAccounts(accounts) {
  return {
    type: FETCH_ADMIN_REQUESTED_DELETE_ACCOUNTS,
    payload: accounts,
  };
}
